module.exports = __webpack_public_path__ + "img/inventory_00.8a700673.png";